import lozad from 'lozad'
const { $ } = window

export default {
	init() {
		let observer
		let $testlink = $('#flipbook-container')
		if ($testlink.length) {
			$testlink.on('click', function () {
				console.log('brochure')
				showFlipbook()
			})
			setTimeout(() => {
				showFlipbook()
			}, 750)
		}

		function showFlipbook() {
			let $activeBook = $('#open_flipbook')
			let toc = [['Cover', 0]]

			$('#magazine > div').each(function (i, el) {
				toc.push(['Page ' + (i + 2), i + 1])
			})
			// console.log(toc)
			//8.5x11 aspect ratio (provided by client)
			let bookOptions = {
				// height: 875,
				// width: 1275,
				height: 2000,
				width: 3090,
				// maxHeight: '90%',
				pageNumbers: false,
				turnPageDuration: 800,
				centeredWhenClosed: true,
				hardcovers: false,
				slideShowDelay: 3000,
				zoomMax: 6,
				// slideShowRunning: true,
				// toolbar: "lastLeft, left, right, lastRight, toc, zoomin, zoomout, slideshow, flipsound, fullscreen, thumbnails",
				toolbar:
					'toc, lastLeft, left, right, lastRight, zoomin, zoomout, slideshow, fullscreen',
				thumbnailsPosition: 'left',
				responsiveHandleWidth: 50,
				flipSound: false,
				// transparentPages: true,
				lightbox: '#open_flipbook',
				lightboxColor: 'rgba(0, 0, 0, 0.9)',
				toolbarPosition: 'top',
				flipSoundPath: '/wp-content/wow_book/sound/',
				toc: toc,
			}

			$('#magazine').wowBook(bookOptions) // create the book

			if (!observer) {
				observer = lozad()
			}
			observer.observe()

			setTimeout(function () {
				$activeBook.click()
			}, 250)
		}
	},
	finalize() {
		// JavaScript to be fired on the services page, after the init JS
	},
}
